import ImageAnswer from './ImageAnswer';

export default ImageAnswer;
